import client from './client';

export interface XRayAnalysis {
  id: number;
  user_id: number;
  original_filename: string;
  xray_type: string | null;
  status: string;
  num_detections: number;
  class_counts: Record<string, number> | null;
  summary: string | null;
  created_at: string;
  analyzed_at: string | null;
  confidence_threshold: number;
  detections: Detection[] | null;
}

export interface Detection {
  class_id: number;
  class_name: string;
  confidence: number;
  bbox: number[];
}

export interface XRayListResponse {
  total: number;
  items: XRayAnalysis[];
}

export const xrayApi = {
  upload: async (file: File, confidenceThreshold: number = 0.25) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await client.post<XRayAnalysis>(
      `/api/xray/upload-sync?confidence_threshold=${confidenceThreshold}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  getList: async (skip: number = 0, limit: number = 20) => {
    const response = await client.get<XRayListResponse>(`/api/xray/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  getAnalysis: async (id: number) => {
    const response = await client.get<XRayAnalysis>(`/api/xray/${id}`);
    return response.data;
  },

  getImageUrl: (id: number) => {
    const token = localStorage.getItem('token');
    return `${client.defaults.baseURL}/api/xray/${id}/image?token=${token}`;
  },

  getResultUrl: (id: number) => {
    const token = localStorage.getItem('token');
    return `${client.defaults.baseURL}/api/xray/${id}/result?token=${token}`;
  },

  delete: async (id: number) => {
    await client.delete(`/api/xray/${id}`);
  },
};
